import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth, isStaff } from "../context/AuthContext";

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        const hash = window.location.hash;
        const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
        if (!sessionId) {
            navigate("/connexion");
            return;
        }
        api
            .post("/auth/google", { session_id: sessionId })
            .then(({ data }) => {
                setUser(data);
                window.history.replaceState(null, "", window.location.pathname);
                navigate(isStaff(data) ? "/admin" : "/", { state: { user: data } });
            })
            .catch(() => navigate("/connexion"));
    }, [navigate, setUser]);

    return (
        <main className="min-h-screen bg-ivory flex items-center justify-center" data-testid="auth-callback">
            <p className="text-ink-soft">Connexion en cours…</p>
        </main>
    );
}
